import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { APP_VERSION } from '../config/version';

const AppFooter = ({ variant = 'full' }) => {
  const year = new Date().getFullYear();

  if (variant === 'minimal') {
    return (
      <footer className="py-4 text-center" data-testid="app-footer">
        <p className="text-xs text-gray-light">
          Kura Stash {APP_VERSION} &middot; &copy; {year} Kura Studio &middot;{' '}
          <Link to="/privacy" className="text-gray-soft hover:text-sage underline transition-colors" data-testid="footer-privacy-link">Privacy</Link>
          {' '}&middot;{' '}
          <Link to="/terms" className="text-gray-soft hover:text-sage underline transition-colors" data-testid="footer-terms-link">Terms</Link>
          {' '}&middot;{' '}
          <Link to="/cookies" className="text-gray-soft hover:text-sage underline transition-colors" data-testid="footer-cookies-link">Cookies</Link>
        </p>
      </footer>
    );
  }

  return (
    <footer className="bg-white border-t border-beige py-10" data-testid="app-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 text-center">
        <div className="flex items-center justify-center space-x-2 mb-3">
          <Sparkles className="h-5 w-5 text-sage" />
          <div className="flex flex-col items-center">
            <span className="text-lg font-light text-charcoal">Kura Stash</span>
            <span className="text-xs text-gray-soft">from <a href="https://kura.shop" target="_blank" rel="noopener noreferrer" className="text-sage hover:text-sage-dark underline">Kura Studio</a></span>
          </div>
        </div>
        <p className="text-gray-light text-xs">
          &copy; {year} Kura Studio. All rights reserved. &middot; {APP_VERSION} &middot;{' '}
          <Link to="/privacy" className="text-gray-soft hover:text-sage underline transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link>
          {' '}&middot;{' '}
          <Link to="/terms" className="text-gray-soft hover:text-sage underline transition-colors" data-testid="footer-terms-link">Terms of Service</Link>
          {' '}&middot;{' '}
          <Link to="/cookies" className="text-gray-soft hover:text-sage underline transition-colors" data-testid="footer-cookies-link">Cookie Policy</Link>
        </p>
      </div>
    </footer>
  );
};

export default AppFooter;
